/**
 * QueryCache — كاش خفيف للطلبات المتكررة من Supabase
 * يحفظ النتائج في الذاكرة لمدة TTL محددة
 * يُبطل الكاش تلقائياً عند أي تحديث (write)
 */

interface CacheEntry<T> {
  data: T;
  timestamp: number;
}

const store = new Map<string, CacheEntry<unknown>>();

// مدة صلاحية الكاش بالمللي ثانية
const DEFAULT_TTL = 10_000; // 10 ثوانٍ فقط — يكفي لتقليل الطلبات المتكررة لكن لا يحتفظ بالبيانات القديمة

export const queryCache = {
  get<T>(key: string, ttl = DEFAULT_TTL): T | null {
    const entry = store.get(key) as CacheEntry<T> | undefined;
    if (!entry) return null;
    if (Date.now() - entry.timestamp > ttl) {
      store.delete(key);
      return null;
    }
    return entry.data;
  },

  set<T>(key: string, data: T): void {
    store.set(key, { data, timestamp: Date.now() });
  },

  invalidate(prefix: string): void {
    for (const key of store.keys()) {
      if (key.startsWith(prefix)) {
        store.delete(key);
      }
    }
  },

  invalidateAll(): void {
    store.clear();
  },
};
